import moment from 'moment';

export function dailyRepairsData(rows, start, end) {
  const first = moment.utc(start, 'YYYY-MM-DD', true);
  const last = moment.utc(end, 'YYYY-MM-DD', true);
  if (!first.isValid() || !last.isValid() || last.isBefore(first)) throw new Error('Choose a valid date range.');
  const totals = new Map();
  rows.forEach(row => {
    const day = moment.utc(row.date).format('YYYY-MM-DD');
    const total = Number(row.total);
    if (!moment.utc(row.date).isValid() || !Number.isFinite(total) || total < 0) throw new Error('Repair totals could not be read. Please retry.');
    totals.set(day, (totals.get(day) || 0) + total);
  });
  const labels = [];
  for (const day = first.clone(); !day.isAfter(last); day.add(1, 'day')) labels.push(day.format('YYYY-MM-DD'));
  return { labels, datasets: [{ label: 'Repairs created', backgroundColor: '#e9c736', data: labels.map(day => totals.get(day) || 0) }] };
}

export function dateTick(value, index, values) {
  if (values.length <= 8) return moment.utc(value).format('MM/DD');
  const count = Math.max(2, Math.min(7, Math.floor((this.width || 280) / 62)));
  const visible = new Set(Array.from({ length: Math.min(count, values.length) }, (_, i) => Math.round(i * (values.length - 1) / Math.max(1, Math.min(count, values.length) - 1))));
  return visible.has(index) ? moment.utc(value).format('MM/DD') : '';
}

export const repairChartOptions = {
  maintainAspectRatio: false,
  legend: { display: false },
  plugins: { datalabels: { display: false } },
  hover: { mode: 'index', intersect: false },
  tooltips: {
    mode: 'index', intersect: false, position: 'nearest', displayColors: false,
    backgroundColor: '#111318', borderColor: '#b2b9bf', borderWidth: 1,
    titleFontSize: 16, bodyFontSize: 14, titleFontColor: '#fff', bodyFontColor: '#fff',
    xPadding: 12, yPadding: 10,
    callbacks: {
      title: (items, data) => items.length ? moment.utc(data.labels[items[0].index]).format('MM/DD/YYYY') : '',
      label: (item, data) => `Repairs created: ${data.datasets[item.datasetIndex].data[item.index]}`
    }
  },
  scales: {
    xAxes: [{
      gridLines: { display: false },
      scaleLabel: { display: false },
      ticks: { fontFamily: 'Nunito Sans', fontColor: '#d7dbe0', fontSize: 12, maxRotation: 0, minRotation: 0, autoSkip: false, callback: dateTick }
    }],
    yAxes: [{ gridLines: { display: false }, ticks: { beginAtZero: true, precision: 0, fontFamily: 'Nunito Sans', fontColor: '#b2b9bf', maxTicksLimit: 5 } }]
  }
};

export const weeklyRepairChartOptions = {
  ...repairChartOptions,
  scales: {
    ...repairChartOptions.scales,
    xAxes: [{
      ...repairChartOptions.scales.xAxes[0],
      ticks: { ...repairChartOptions.scales.xAxes[0].ticks, maxRotation: 45 }
    }]
  }
};
